module.exports = __webpack_public_path__ + "fonts/NouvelR-Variable.545841d3.ttf";